<section class="titulo">
    <p>
        <br><br>
    </p>
    <div class="titleImagen">
        <p style="line-height: 100%;" class="fontMS700 colorPrincipal font-45">
            LOS DERECHOS DE LA<br> 
            MUJER PERUANA (1910-1956) <br>
        </p>
        <div id="sharePic">
            <a (click)="test.toggle()" mdbWavesEffect>
                <img width="200px" src="/assets/images/general/MP_BOTON_COMPARTIR.jpg">
            </a>
            <div mdbCollapse #test="bs-collapse">
                <div class="divShared">
                    &nbsp;
                    &nbsp;
                    <a target="_blank"
                        href="http://www.facebook.com/sharer.php?u=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio20/derechos-mujer">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_FB.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://api.whatsapp.com/send?text=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio20/derechos-mujer">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_INST.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://twitter.com/intent/tweet?text=MemoriaPeru&url=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio20/derechos-mujer">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_TW.png">
                    </a>
                </div>
            </div>
        </div>
    </div>
    <img class="img_portada" src="/assets/images/micrositio/micrositio20/MUJER-000.jpg">
</section>
<div class="fondoBlanco_Intro">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <p class="fontMS500 text-justify font-24">
                    CON EL SIGLO XX, LLEGARON GRANDES TRANSFORMACIONES POLÍTICAS,
                    ECONÓMICAS Y SOCIALES. LAS MUJERES, DE DIVERSAS CLASES SOCIALES,
                    PARTICIPABAN CADA VEZ MÁS EN LA ESFERA PÚBLICA. REALIZABAN ESTUDIOS
                    UNIVERSITARIOS, OCUPABAN NUEVOS CARGOS PROFESIONALES Y ASUMÍAN UN ROL
                    ACTIVO EN LA POLÍTICA LOCAL, NACIONAL E INTERNACIONAL. AÚN ASÍ, NO
                    CONTABAN CON DERECHOS BÁSICOS, TALES COMO EL VOTO POLÍTICO O LA
                    POSESIÓN DE SUS PROPIOS BIENES.
                </p>
                <p class="fontMS100 text-justify font-24">
                    <br>
                    Los documentos a continuación trazan la ardua lucha por los derechos de la mujer 
                    peruana en la primera mitad del siglo XX. Se construye a partir del acervo de la 
                    Hemeroteca Nacional y las colecciones de María Jesús Alvarado, Zoila Aurora Cáceres 
                    y Magda Portal preservadas en la Biblioteca Nacional del Perú. El recorrido indaga 
                    en el acceso a la educación, a los trabajos profesionales y el divorcio. Se detiene 
                    para examinar el largo camino hacia el sufragio, siempre en diálogo con el feminismo 
                    transnacional y las tensiones políticas nacionales. Cierra con una exploración literaria 
                    de la mujer moderna, considerando el impacto de todas estas transformaciones en la 
                    subjetividad femenina.
                </p>
            </div>
        </div>
    </div>
</div>
<div class="fondoGris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 100%;margin-bottom: 0%;padding-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-38">
                            EVOLUCIÓN FEMENINA
                        </p>
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                </div>
                
                <div class="row">
                    <div class="col-sm-12 mt-5">
                        <p class="fontMS500 font-24">
                            <br>
                            EL 28 DE OCTUBRE DE 1911, EN LA SALA DE CONFERENCIAS DE LA BIBLIOTECA
                            NACIONAL, MARÍA JESÚS ALVARADO PRESENTÓ UN DISCURSO A FAVOR DE LA
                            IGUALDAD ENTRE LOS HOMBRES Y LAS MUJERES.
                            <br><br>
                        </p>
                        <p class="fontMS100 text-justify font-24">
                            Refutó los principales argumentos contra el feminismo en ese momento, demostrando que la
                            subyugación de la mujer es solo un hábito impuesto por la sociedad sin ninguna justificación
                            científica. Con miras al futuro, propone una serie de reformas vinculadas con la educación, el
                            sufragio femenino y el acceso a los cargos profesionales y políticos.
                            <br><br>
                        </p>
                        <p class="fontMS100 text-justify font-24">
                            Unos años después, funda la organización Evolución Femenina para impulsar estas reformas. El
                            nombre representa su concepción del feminismo, es decir, una evolución progresiva, paso a
                            paso, desde la subyugación hacia la liberación.
                        </p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-6 libro mt-5">
                        <img class="img-fluid pd-10" width="100%" 
                                src="/assets/images/micrositio/micrositio20/MUJER-001.jpg">
                        <br><br>
                        <p class="fontMS100Italic pd-10">
                            María Jesús Alvarado (Chincha Alta, 1878 – Lima, 1971)
                            Fuente: CMP Flora Tristán.</p>
                        <!--<p class="fontMS100Italic text-right pd-10 bottom_cel" style="margin-top: 24%;">
                            María Jesús Alvarado. Fuente: CMP Flora Tristán.</p>-->    
                    </div>
                    <div class="col-sm-6">
                        <div class="row">
                            <div class="col-sm-6 libro mt-5">
                                <a href="http://hdl.handle.net/20.500.14428/79602" target="_blank" style="color: black;">
                                    <img width="100%" 
                                        src="/assets/images/micrositio/micrositio20/MUJER-002.jpg">
                                    <div class="overlay">
                                        <p class="fontMS100 text-center">
                                            <span class="fontMS500">
                                                María Jesús Alvarado. 
                                                <br>
                                            </span>
                                            El feminismo: conferencia leída en la Sociedad Geográfica de Lima el 28 de octubre de 1911.   
                                        </p>
                                    </div>
                                </a>
                            </div>
                            <div class="col-sm-6 libro mt-5">
                                <a href="http://hdl.handle.net/20.500.14428/79169" target="_blank" style="color: black;">
                                    <img width="100%" 
                                        src="/assets/images/micrositio/micrositio20/MUJER-003.jpg">
                                    <div class="overlay">
                                        <p class="fontMS100 text-center">
                                            <span class="fontMS500">
                                                María Jesús Alvarado. 
                                                <br>
                                            </span>
                                            <span class="fontMS100Italic">
                                                Institución Evolución Femenina: Exposición de principios. 
                                                <br>
                                            </span>
                                            Lima: Imprenta Peruana, 1914. 
                                        </p>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="row mt-5">
                            <div class="col-sm-12">
                                <img width="100%" 
                                        src="/assets/images/micrositio/micrositio20/MUJER-004.jpg">
                                <p class="fontMS100Italic bottom_cel">
                                    <br>
                                    María Jesús Alvarado. Fuente: CMP Flora Tristán.</p>
                            </div>
                            <div class="c100">
                                <p class="fontMS100Italic">
                                    María Jesús Alvarado. Fuente: CMP Flora Tristán.</p>   
                            </div>
                        </div> 
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="fondoAzulO">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 100%;margin-bottom: 0%;padding-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-38">
                            IGUALDAD ANTE LA LEY
                        </p>
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                </div>
                <br><br>
                <div class="row mt-5">
                    <div class="col-sm-5 libro">
                        <img class="img-fluid pd-10" width="100%" 
                                src="/assets/images/micrositio/micrositio20/MUJER-005.jpg">
                        <p class="fontMS100Italic" style="color:grey;"><br> Miguelina Acosta Cárdenas
                            (Yurimaguas, 1887-1933)
                            Fuente: Herederos de Miguelina Acosta</p>
                    </div>
                    <div class="col-sm-7 bottom_cel">
                        <p class="fontMS500 text-white font-24 pi-10">
                            MIGUELINA ACOSTA, LA PRIMERA
                            ABOGADA LITIGANTE DEL PAÍS, TRABAJÓ
                            A FAVOR DE LOS DERECHOS DE LAS
                            MUJERES, LOS OBREROS Y LOS
                            INDÍGENAS. DIRIGIÓ <span class="fontMS500Italic">LA CRÍTICA:
                            SEMANARIO INDEPENDIENTE</span> CON DORA
                            MAYER ENTRE 1917 Y 1920, Y EN ESTA
                            PUBLICACIÓN SE DESTACA EL TRABAJO
                            MULTIFACÉTICO DE AMBAS ACTIVISTAS. A
                            TRAVÉS DE REPORTAJES, ENSAYOS Y
                            OBRAS LITERARIAS, ABORDAN TEMAS
                            COMO EL EMERGENTE MOVIMIENTO
                            SINDICAL, LA REFORMA UNIVERSITARIA,
                            EL FEMINISMO Y LA DEFENSA DE LOS
                            DERECHOS DE LOS INDÍGENAS.
                        </p>
                    </div>
                    <div class="col-sm-12 c100">
                        <p class="fontMS500 text-white font-24">
                            MIGUELINA ACOSTA, LA PRIMERA
                            ABOGADA LITIGANTE DEL PAÍS, TRABAJÓ
                            A FAVOR DE LOS DERECHOS DE LAS
                            MUJERES, LOS OBREROS Y LOS
                            INDÍGENAS. DIRIGIÓ <span class="fontMS500Italic">LA CRÍTICA:
                            SEMANARIO INDEPENDIENTE</span> CON DORA
                            MAYER ENTRE 1917 Y 1920, Y EN ESTA
                            PUBLICACIÓN SE DESTACA EL TRABAJO
                            MULTIFACÉTICO DE AMBAS ACTIVISTAS. A
                            TRAVÉS DE REPORTAJES, ENSAYOS Y
                            OBRAS LITERARIAS, ABORDAN TEMAS
                            COMO EL EMERGENTE MOVIMIENTO
                            SINDICAL, LA REFORMA UNIVERSITARIA,
                            EL FEMINISMO Y LA DEFENSA DE LOS
                            DERECHOS DE LOS INDÍGENAS.
                        </p>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-sm-12">
                        <p class="fontMS100 text-justify text-white font-24">
                            En paralelo, Acosta sustentó su tesis doctoral en la Facultad de Derecho de la Universidad
                            Nacional Mayor de San Marcos. Dicho documento ofrece un análisis minucioso del código civil
                            peruano, acompañado por recomendaciones de la autora para asegurar la igualdad jurídica entre
                            los hombres y las mujeres.
                        </p>
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col-sm-4 libro">
                        <a href="https://hdl.handle.net/20.500.14428/72795" target="_blank" style="color: black;">
                            <img class="img-fluid" width="100%" 
                                src="/assets/images/micrositio/micrositio20/MUJER-006.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        Miguelina Acosta Cárdenas. 
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        Reformas necesarias del Código civil común peruano tendientes 
                                        a hacer efectiva la igualdad civil y jurídica del hombre y la mujer.  
                                        <br>
                                    </span>
                                    Imprenta Peruana, 1920. 
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-5 bottom_cel" style="margin-top:18%;">
                        <div class="pi-10">
                            <img width="100%" src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA2.jpg">
                            <a href="http://hdl.handle.net/20.500.14428/79609" target="_blank" style="color: black; text-decoration: none;">
                                <p class="fontMS500 text-white font-24" style="margin:0%;">
                                    <span class="fontMS500Italic text-white">La Crítica,</span> Año 1, no. 15,<br>
                                    16 de diciembre de 1917.
                                </p>
                            </a>
                            <img width="100%" src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA2.jpg">
                            <a href="http://hdl.handle.net/20.500.14428/79611" target="_blank" style="color: black; text-decoration: none;">
                                <p class="fontMS500 text-white font-24" style="margin:0%;">
                                    <span class="fontMS500Italic text-white">La Crítica,</span> Año 1, no. 22,<br>
                                    3 de febrero de 1918.
                                </p>
                            </a>
                            <img width="100%" src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA2.jpg">
                            <a href="http://hdl.handle.net/20.500.14428/79610" target="_blank" style="color: black; text-decoration: none;">
                                <p class="fontMS500 text-white font-24" style="margin:0%;">
                                    <span class="fontMS500Italic text-white">La Crítica,</span> Año 2, no. 97,<br>
                                    1 de agosto de 1919.
                                </p>
                            </a>
                            <img width="100%" src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA2.jpg">
                        </div>
                    </div>
                    <div class="col-sm-5 c100" style="margin-top:18%;">
                        <img width="100%" src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA2.jpg">
                        <a href="http://hdl.handle.net/20.500.14428/79609" target="_blank" style="color: black; text-decoration: none;">
                            <p class="fontMS500 text-white font-24" style="margin:0%;">
                                <span class="fontMS500Italic text-white">La Crítica,</span> Año 1, no. 15,<br>
                                16 de diciembre de 1917.
                            </p>
                        </a>
                        <img width="100%" src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA2.jpg">
                        <a href="http://hdl.handle.net/20.500.14428/79611" target="_blank" style="color: black; text-decoration: none;">
                            <p class="fontMS500 text-white font-24" style="margin:0%;">
                                <span class="fontMS500Italic text-white">La Crítica,</span> Año 1, no. 22,<br>
                                3 de febrero de 1918.
                            </p>
                        </a>
                        <img width="100%" src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA2.jpg">
                        <a href="http://hdl.handle.net/20.500.14428/79610" target="_blank" style="color: black; text-decoration: none;">
                            <p class="fontMS500 text-white font-24" style="margin:0%;">
                                <span class="fontMS500Italic text-white">La Crítica,</span> Año 2, no. 97,<br>
                                1 de agosto de 1919.
                            </p>
                        </a>
                        <img width="100%" src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA2.jpg">
                    </div>
                    <div class="col-sm-3"></div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoGris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <img src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA_RESALTE.png" width="100%">
                <p class="fontMS500 text-justify font-22">
                    <br>
                    EL PRINCIPIO FUNDAMENTAL DEL FEMINISMO ES LA IGUALDAD DE LA
                    POTENCIALIDAD MENTAL Y DE LA HABILIDAD PARA EL TRABAJO DEL
                    HOMBRE Y LA MUJER, IGUALDAD PROBADA IRREFUTABLEMENTE POR LA
                    HISTORIA, Y HASTA POR LA SOMERA OBSERVACIÓN DE LA VIDA DIARIA,
                    POR CUYA IDENTIDAD DE PERSONALIDADES, ES DE ABSOLUTA JUSTICIA
                    QUE SEAN IGUALES ANTE LA LEY, LIBERTÁNDOSE LA MUJER DE LA
                    FORZOSA Y MUCHAS VECES TIRÁNICA Y CRUEL TUTELA DEL HOMBRE, QUE
                    NINGÚN DERECHO TIENE A EJERCER SUPREMACÍA EN LA PAREJA HUMANA.
                    <br>
                </p>
                <p class="text-right fontMS500Italic font-22">
                    <span>
                        María Jesús Alvarado, 1911
                    </span>
                    <br>
                </p>
                <img src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA_RESALTE.png" class="reflejo"
                    width="100%">
            </div>
        </div>
    </div>
</div>


<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <p style="line-height: 100%;margin-bottom: 0%;" class="fontMS700 font-40 colorPrincipal">
                            EL FEMINISMO <br>
                            TRANSNACIONAL
                        </p>
                    </div>
                    <div class="col-sm-8">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1.png">
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="col-sm-12">
                        <p class="fontMS500 font-24">
                            EN EL CONTEXTO DE LA PRIMERA GUERRA MUNDIAL (1914-1918), LA ACTIVISTA
                            PERUANA DORA MAYER SE DECLARÓ PACIFISTA. EN EL ARTÍCULO A
                            CONTINUACIÓN, COMENTA EL VÍNCULO ENTRE EL FEMINISMO
                            SUFRAGISTA Y EL PACIFISMO, Y CONVOCA A SUS COMPATRIOTAS A FORMAR
                            UNA DELEGACIÓN PARA REPRESENTAR AL PERÚ EN LA LIGA INTERNACIONAL DE
                            MUJERES POR LA PAZ Y LA LIBERTAD.
                        </p>
                        <br>
                        <p class="fontMS100 font-24 text-justify" style="color:gray">
                            Asimismo, la Segunda Conferencia Panamericana de Mujeres se celebró en Lima entre 1924 y
                            1925 y convocó a activistas e intelectuales de doce países americanos para debatir el rol de la
                            mujer en la sociedad. En el marco del simposio, la educadora Elvira García y García presentó <span class="fontMS100Italic">La
                            mujer peruana a través de los siglos</span>, un diccionario biográfico que abarca desde las culturas
                            originarias hasta las primeras décadas del siglo XX.
                        </p>
                    </div>
                </div>

                <div class="row mt-4">
                    <div class="col-sm-4">
                        <a href="https://hdl.handle.net/20.500.14428/36989" target="_blank" style="color: black; text-decoration: none;">
                            <img class="img-fluid" width="100%" 
                                src="/assets/images/micrositio/micrositio20/MUJER-007.jpg">
                        </a>
                    </div>
                    <div class="col-sm-5 bottom_cel" style="margin-top:31%;">
                        <div class="pi-10">
                            <img width="100%" src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA2.jpg">
                            <a href="http://hdl.handle.net/20.500.14428/79628" target="_blank" style="color: black; text-decoration: none;">
                                <p class="fontMS500 font-24" style="margin:0%;">
                                    Dora Mayer <br>
                                    <span class="fontMS500Italic">La mujer y el pacifismo.</span><br>
                                    El Comercio, 1 de enero de 1921.
                                </p>
                            </a>
                            <img width="100%" src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA2.jpg">
                        </div>
                    </div>
                    <div class="col-sm-5 c100" style="margin-top:5%;">
                        <img width="100%" src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA2.jpg">
                        <a href="http://hdl.handle.net/20.500.14428/79628" target="_blank" style="color: black; text-decoration: none;">
                            <p class="fontMS500 font-24" style="margin:0%;">
                                Dora Mayer <br>
                                <span class="fontMS500Italic">La mujer y el pacifismo.</span><br>
                                El Comercio, 1 de enero de 1921.
                            </p>
                        </a>
                        <img width="100%" src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA2.jpg">
                        
                    </div>
                    <div class="col-sm-3"></div>
                </div>
                <div class="row mt-5">
                    <div class="col-sm-12">
                        <img class="img-fluid" width="100%" 
                                src="/assets/images/micrositio/micrositio20/MUJER-008.jpg">
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <p class="fontMS100Italic" style="color:grey;">
                            <br> 
                            Consejo Nacional de Mujeres del Perú, 1923. En el centro
                            aparece Mrs. Carrie Chapman Catt; a su derecha María Jesús
                            Alvarado, Julia Codesido y Julia Delaney. A la izquierda Luisa
                            Dammert, María Engracia de Fryer. De pie: Rosa D. Pérez
                            Liendo, Zenaida Moselli Conroy, Cristina Morter. Fuente:
                            Archivo María Jesús Alvarado. CMP Flora Tristán.
                        </p>
                    </div>
                    <div class="col-sm-6"></div>
                </div>
                <p>
                    <br><br>
                    <img width="100%" src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA2.jpg">
                    <br><br><br><br>
                </p>
                <div class="row">
                    <div class="col-sm-6">
                        <p style="line-height: 100%;margin-bottom: 0%;" class="fontMS700 font-40 colorPrincipal">
                            ZOILA AURORA CÁCERES <br>
                            Y EL FEMINISMO PERUANO
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="col-sm-12">
                        <p class="fontMS500 font-24">
                            SIENDO HIJA DEL PRESIDENTE ANDRÉS AVELINO CÁCERES (1886-90, 94-95),
                            ZOILA AURORA VIAJÓ EXTENSAMENTE POR EUROPA Y AMÉRICA, DONDE SE
                            FORMÓ COMO FEMINISTA Y CRÍTICA CULTURAL.
                            <br><br>
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6 libro">
                        <a href="https://hdl.handle.net/20.500.14428/4766" target="_blank" style="color: black;">
                            <img class="img-fluid pd-10" width="100%"
                                src="/assets/images/micrositio/micrositio20/MUJER-009.jpg">
                            <div class="overlay-img-2">
                                <p class="fontMS500 text-center">
                                    Zoila Aurora Cáceres Moreno (Lima, 1877- Madrid, 1958)
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-4">
                        <p class="fontMS100 font-24">
                            En 1924, de vuelta en Perú, fundó el
                            colectivo Feminismo Peruano con
                            el objetivo de avanzar en los
                            derechos políticos, económicos y
                            sociales de la mujer. Para avanzar la
                            causa del sufragio, sostuvo
                            correspondencia activa con los
                            principales intelectuales y políticos
                            del momento.
                        </p>
                        <br>
                        <p class="fontMS100 font-24">
                            Se solidarizó además con la clase
                            obrera y las comunidades
                            indígenas, y abogó por los derechos
                            de las mujeres que ocupan nuevos
                            espacios profesionales. En 1930
                            impulsó la creación del primer
                            sindicato de costureras y al año
                            siguiente organizó la primera
                            huelga de telefonistas.
                        </p>
                    </div>
                    <div class="col-sm-2"></div>
                </div>
            </div>
        </div>
    </div>
    <!--CARROUSEL-->
    <div class="w-90 text-center ml-auto mr-auto">
        <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig">
            <div ngxSlickItem *ngFor="let slide of slides" class="slide p-2">
                <div class="divLibros text-center w-100">
                    <a style="color: inherit;" href="{{slide.id}}" target="_blank">
                        <p class="text-center">
                            <img src="{{ slide.img }}" width="100%">
                        </p>
                        <div class="divNombresLibros">
                            <p class="text-center">
                                <span class="fontMS500">{{slide.autor}}</span><br>
                                <span class="fontMS100">{{slide.anuNacimiento}}</span><br>
                                <span class="fontMS100">{{slide.anno}}</span>
                            </p>
                        </div>
                    </a>
                </div>
            </div>
        </ngx-slick-carousel>
    </div>
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-6 text-center">
                        <p style="line-height: 100%;margin-bottom: 0%;" class="fontMS700 font-40 colorPrincipal">
                            LA LUCHA POR EL SUFRAGIO
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                </div>
                <p style="line-height: 120%;margin-top: 0%;margin-bottom: 0%;"
                    class="fontMS700 text-center colorPrincipal font-40">
                    CONTINÚA
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                </div>
                <div class="row mt-5">
                    <div class="col-sm-12">
                        <p class="fontMS500 font-24 text-justify">
                            A PESAR DE LA LABOR CONSTANTE DE ACTIVISTAS COMO MARÍA JESÚS
                            ALVARADO, ZOILA AURORA CÁCERES, ÁNGELA RAMOS, DORA MAYER Y MAGDA
                            PORTAL, LAS DIVERSAS FACCIONES QUE CONFORMARON EL CONGRESO
                            CONSTITUYENTE NO LLEGARON A UN CONSENSO RESPECTO AL VOTO
                            POLÍTICO, Y SOLO CEDIERON EL VOTO MUNICIPAL PARA LAS MUJERES MAYORES
                            DE EDAD, CASADAS O MADRES DE FAMILIA QUE SABEN LEER Y ESCRIBIR EN
                            CASTELLANO.
                        </p>
                        <br>
                        <p class="fontMS100 font-24 text-justify" style="color:gray">
                            En el folleto “El aprismo y la mujer”, Magda Portal admite sentirse decepcionada con el resultado
                            del Congreso Constituyente, pero no abandona su labor política. Con la creación de la Sección
                            Femenina del APRA, viaja por todo el país para brindar talleres y conferencias de formación
                            política. Ella busca “despertar en las mujeres – clases medias, obreras y campesinas - la
                            conciencia de la lucha social, el anhelo de mejoramiento económico, la necesidad de sus
                            reivindicaciones políticas”.
                        </p>
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="col-sm-4 libro mt-4">
                        <a href="http://hdl.handle.net/20.500.14428/79632" target="_blank" style="color: black;">
                            <img width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio20/MUJER-017.jpg">
                            <div class="overlay">
                                <p class="fontMS500 text-center">
                                    Votos en discordia sobre algunos puntos del anteproyecto de ley 
                                    electoral elevado al gobierno. <br>
                                    La Prensa, 25 de abril de 1931.

                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-4 libro mt-4">
                        <a href="http://hdl.handle.net/20.500.14428/79634" target="_blank" style="color: black;">
                            <img width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio20/MUJER-018.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        Dora Mayer de Zulen 
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        El sufragio. 
                                        <br>
                                    </span>
                                    El Callao, 14 de enero de 1932.
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-4 libro mt-4">
                        <a href="http://hdl.handle.net/20.500.14428/79172" target="_blank" style="color: black;">
                            <img width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio20/MUJER-019.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        Magda Portal
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        El aprismo y la mujer.
                                        <br>
                                    </span>
                                    Editorial Atahualpa, 1933.
                                </p>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="col-sm-12 libro">
                        <img class="img-fluid" width="100%"
                                src="/assets/images/micrositio/micrositio20/MUJER-020.jpg">
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-sm-6">
                        <p class="fontMS100Italic">
                            Convención de mujeres apristas. Lima, 1946. <br>
                            Fuente: Archivo de Rocío Revolledo.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoGris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-8">
                        <p style="line-height: 100%;margin-bottom: 0%;" class="fontMS700 font-40 colorPrincipal">
                            MUJERES ELECTAS POR PRIMERA VEZ
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq2" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                </div>
                
                <div class="row mt-5">
                    <div class="col-sm-12">
                        <p class="fontMS500 font-24">
                            SON HISTÓRICAS LAS ELECCIONES
                            MUNICIPALES DE 1945, PORQUE
                            FUE LA PRIMERA VEZ, A PESAR DE
                            LO QUE ESTABLECÍA LA
                            CONSTITUCIÓN DE 1933, QUE LAS
                            MUJERES EJERCÍAN SU DERECHO
                            AL SUFRAGIO Y A SER ELEGIDAS.
                            FUERON ELECTAS A CARGOS
                            PÚBLICOS ALCALDESAS,
                            TENIENTES ALCALDESAS Y
                            CONCEJALES.
                        </p>
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="col-sm-12">
                        <a href="http://hdl.handle.net/20.500.14428/79640" target="_blank" style="color: black;">
                            <img width="100%"
                                src="/assets/images/micrositio/micrositio20/MUJER-021.jpg">
                        </a>
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="col-sm-12">
                        <p class="fontMS100 font-24 text-justify" style="color:gray">
                            María Jesús Alvarado se destaca por su dedicación constante a la causa del sufragio femenino.
                            Gracias a sus esfuerzos, y al trabajo de Zoila Aurora Cáceres, Magda Portal, Ángela Ramos, entre
                            otras, la mujer por fin logra el voto político. En 1956, tras la promulgación de la ley 12391 por el
                            Presidente Manuel Odría, las mujeres participan por primera vez en las elecciones nacionales.
                        </p>
                        <br>
                        <p class="fontMS100 font-24 text-justify" style="color:gray">
                            Sin embargo, el voto aún es restringido a las mujeres que sabían leer y escribir en castellano. No
                            es hasta 1979 que el derecho al sufragio se extiende a todos los peruanos y peruanas.
                        </p>
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="col-sm-2"></div>
                    <div class="col-sm-4 libro mt-4">
                        <a href="http://hdl.handle.net/20.500.14428/79637" target="_blank" style="color: black;">
                            <img width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio20/MUJER-022.jpg">
                            <div class="overlay">
                                <p class="fontMS500 text-center">
                                    Las mujeres en las municipalidades 
                                    La Tribuna, 15 de octubre de 1945. 

                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-4 libro mt-4">
                        <a href="http://hdl.handle.net/20.500.14428/79633" target="_blank" style="color: black;">
                            <img width="100%" height="100%"
                                src="/assets/images/micrositio/micrositio20/MUJER-023.jpg">
                            <div class="overlay">
                                <p class="fontMS500 text-center">
                                    Dora Madueño de Bedoya, primera alcaldesa del Perú (Huancané, Puno). 
                                    La Tribuna, 24 de octubre de 1945. 

                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-2"></div>
                </div>
                <div class="row mt-5">
                    <div class="col-sm-8 libro">
                        <img class="img-fluid" width="100%" 
                                src="/assets/images/micrositio/micrositio20/MUJER-024.jpg">
                    </div>
                    <div class="col-sm-4 bottom_cel" style="margin-top:31%;">
                        <div class="pi-10">
                            <img width="100%" src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA2.jpg">
                            <a href="http://hdl.handle.net/20.500.14428/79639" 
                                target="_blank" style="text-decoration:none; color:black;">
                                <p class="fontMS100 font-22" style="margin:0%;">
                                    <span class="fontMS100Italic">En gran número y con alto civismo
                                        la mujer acudió a emitir su voto.</span><br>
                                        La Prensa, 18 de junio de 1956
                                </p>
                            </a>
                            <img width="100%" src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA2.jpg">
                            <a href="http://hdl.handle.net/20.500.14428/79638" 
                                target="_blank" style="text-decoration:none; color:black;">
                                <p class="fontMS100 font-22" style="margin:0%;">
                                    <span class="fontMS100Italic">Una vida de lucha por los derechos
                                        de la mujer.</span><br>
                                        El Comercio, 17 de junio de 1959.
                                </p>
                            </a>
                            <img width="100%" src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA2.jpg">
                        </div>
                    </div>
                    <div class="col-sm-4" style="margin-top:5%;">
                        <img width="100%" src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA2.jpg">
                        <a href="http://hdl.handle.net/20.500.14428/79639" 
                            target="_blank" style="text-decoration:none; color:black;">
                            <p class="fontMS100 font-22" style="margin:0%;">
                                <span class="fontMS100Italic">En gran número y con alto civismo
                                    la mujer acudió a emitir su voto.</span><br>
                                    La Prensa, 18 de junio de 1956
                            </p>
                        </a>
                        <img width="100%" src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA2.jpg">
                        <a href="http://hdl.handle.net/20.500.14428/79638" 
                            target="_blank" style="text-decoration:none; color:black;">
                            <p class="fontMS100 font-22" style="margin:0%;">
                                <span class="fontMS100Italic">Una vida de lucha por los derechos
                                    de la mujer.</span><br>
                                    El Comercio, 17 de junio de 1959.
                            </p>
                        </a>
                        <img width="100%" src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA2.jpg">
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-12">
                        <p style="line-height: 100%;margin-bottom: 0%;padding-bottom: 0%;"
                            class="fontMS700 colorPrincipal font-38">
                            POR SENDA PROPIA
                        </p>
                        <p style="line-height: 120%;margin-top: 0%;margin-bottom: 0%;"
                            class="fontMS100 colorPrincipal font-40">
                            REPRESENTACIONES LITERARIAS
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-5">
                        <p style="line-height: 120%;margin-top: 0%;margin-bottom: 0%;"
                            class="fontMS100 colorPrincipal font-40">
                            DE LA MUJER MODERNA
                        </p>
                    </div>
                    <div class="col-sm-7">
                        <img class="LineSubsec_Izq2" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                </div>
                <br><br>
                <div class="row">
                    <div class="col-sm-5">
                        <img class="img-fluid" width="100%" 
                                src="/assets/images/micrositio/micrositio20/MUJER-025.jpg">
                        <p class="fontMS100Italic" style="color:grey;"><br> Angélica Palma 
                            (Lima, 1878 – Rosario, 1935). Foto:
                            Diego Goyzueta. Fuente: Instituto Riva-Agüero.
                            PUCP.</p>
                    </div>
                    <div class="col-sm-5">
                        <p class="fontMS500 font-24 mt-5">
                            MIENTRAS LA MUJER PERUANA OCUPABA
                            NUEVOS ESPACIOS ECONÓMICOS,
                            POLÍTICOS, SOCIALES Y LABORALES, EN LA
                            LITERATURA ESCRITA POR MUJERES
                            SURGÍAN PERSONAJES FEMENINOS CADA
                            VEZ MÁS LIBRES E INDEPENDIENTES,
                            MUJERES QUE ESTUDIAN Y TRABAJAN,
                            QUE PUEDEN DECIDIR SI QUIEREN
                            CASARSE O SER MADRES.
                        </p>
                    </div>
                    <div class="col-sm-2"></div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <p class="fontMS100 text-justify font-22" style="color:gray;">
                            En la mayoría de estas obras, la protagonista choca con las expectativas de la sociedad tradicional
                            y de sus propios familiares. En el caso de las escritoras vanguardistas, en cambio, el personaje
                            femenino enfrenta nuevos problemas sociales y éticos, como el aborto, el divorcio y la soledad.
                        </p>
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="col"></div>
                    <div class="col-sm-3 libro mt-4">
                        <a href="http://hdl.handle.net/20.500.14428/79168" target="_blank" style="color: black;">
                            <img class="img-fluid" width="100%" 
                                src="/assets/images/micrositio/micrositio20/MUJER-026.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        Leonor Espinoza de Menéndez.
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        Zarela: una novela feminista.
                                        <br>
                                    </span>
                                    Arequipa: Tip. Franklin, 1915.
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-3 libro mt-4">
                        <a href="https://hdl.handle.net/20.500.14428/11621" target="_blank" style="color: black;">
                            <img class="img-fluid" width="100%" 
                                src="/assets/images/micrositio/micrositio20/MUJER-027.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        Angélica Palma.
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        Por senda propia.
                                        <br>
                                    </span>
                                    Lima : E. Rosay, 1921 
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-3 libro mt-4">
                        <a href="http://hdl.handle.net/20.500.14428/79164" target="_blank" style="color: black;">
                            <img class="img-fluid" width="100%" 
                                src="/assets/images/micrositio/micrositio20/MUJER-028.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        Zoila Aurora Cáceres. 
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        Ciudad del sol. 
                                        <br>
                                    </span>
                                    Lima: E. Rosay, 1927.
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col"></div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoAzulO">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="c100">
                            <img class="lineCel" width="100%"
                                src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                        </div>
                        <p style="line-height: 100%;margin-bottom: 0%;padding-bottom: 0%;"
                            class="fontMS700 colorPrincipal font-40 text-center">
                            UNA MUJER MODERNA
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 120%;margin-top: 0%;margin-bottom: 0%;"
                            class="fontMS700 colorPrincipal font-40 text-center">
                            QUE BAILA EL CHARLESTON
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                </div>
                <br><br>
                <div class="row">
                    <div class="col-sm-5">
                        <img class="img-fluid" width="100%" 
                                src="/assets/images/micrositio/micrositio20/MUJER-029.jpg">
                        <p class="fontMS100Italic" style="color:grey;"><br> Rosa Arciniega (Lima, 1909-Buenos Aires,
                            1999)<br>
                            Archivo de la Biblioteca de la Universidad
                            de Texas en Austin, Colección
                            Latinoamericana Nettie Lee Benson.</p>
                    </div>
                    <div class="col-sm-6 bottom_cel">
                        <p class="fontMS500 font-24 mt-5 text-white pi-10">
                            EN LA NARRATIVA VANGUARDISTA, EL ROL TRADICIONAL DE LA MUJER PASA A SEGUNDO PLANO. AÚN ASÍ, 
                            LOS PERSONAJES FEMENINOS SE ENCUENTRAN EN UNA ATMÓSFERA SOFOCANTE. ÁNGELA RAMOS SATIRIZA LA 
                            IDEA DEL AMOR ROMÁNTICO DESDE LA PERSPECTIVA DE LA ESPOSA DE UN POETA RECONOCIDO MIENTRAS QUE 
                            MAGDA PORTAL RETRATA EL PESO DEL TRÁGICO CICLO DE LA POBREZA EN EL CUENTO “CÍRCULOS VIOLETA”. 
                            FINALMENTE, EN EL CUENTO “CÉLULAS DE ENLACE”, ROSA ARCINIEGA TRANSMITE LA SOLEDAD DE LA GRAN 
                            URBE DESDE LA PERSPECTIVA DE LA TELEFONISTA ANÓNIMA.
                        </p>
                    </div>
                    <div class="col-sm-6 c100">
                        <p class="fontMS500 font-24 mt-5 text-white">
                            EN LA NARRATIVA VANGUARDISTA, EL ROL TRADICIONAL DE LA MUJER PASA A SEGUNDO PLANO. AÚN ASÍ, 
                            LOS PERSONAJES FEMENINOS SE ENCUENTRAN EN UNA ATMÓSFERA SOFOCANTE. ÁNGELA RAMOS SATIRIZA LA 
                            IDEA DEL AMOR ROMÁNTICO DESDE LA PERSPECTIVA DE LA ESPOSA DE UN POETA RECONOCIDO MIENTRAS QUE 
                            MAGDA PORTAL RETRATA EL PESO DEL TRÁGICO CICLO DE LA POBREZA EN EL CUENTO “CÍRCULOS VIOLETA”. 
                            FINALMENTE, EN EL CUENTO “CÉLULAS DE ENLACE”, ROSA ARCINIEGA TRANSMITE LA SOLEDAD DE LA GRAN 
                            URBE DESDE LA PERSPECTIVA DE LA TELEFONISTA ANÓNIMA.
                        </p>
                    </div>
                    <div class="col-sm-1"></div>
                </div>

                <div class="row mt-5">
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada2.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-6 text-center">
                        <p style="line-height: 100%;margin-bottom: 0%;" class="fontMS700 font-40 colorPrincipal">
                            LA RADIO Y EL IMAGINARIO
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada2.png">
                    </div>
                </div>
                <p style="line-height: 120%;margin-top: 0%;margin-bottom: 0%;"
                    class="fontMS500 text-center colorPrincipal font-40">
                    NACIONAL
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                </div>
                <div class="row mt-5">
                    <div class="col-sm-5">
                        <img width="100%" 
                                src="/assets/images/micrositio/micrositio20/MUJER-030.jpg">
                        <p class="fontMS100Italic" style="color:grey;">
                            <br> 
                            Para la locutora Maruja Venegas Salinas la función de la radio era ayudar, 
                            educar y a la vez entretener. Semanario Extra, 20 de diciembre de 1955. </p>
                    </div>
                    <div class="col-sm-6 bottom_cel">
                        <p class="fontMS500 font-24 mt-5 text-white pi-10">
                            MARÍA JESÚS ALVARADO ESCRIBIÓ LA
                            PRIMERA PARTE DE LA PERRICHOLI EN
                            1936, MIENTRAS ESTUVO EXILIADA EN
                            ARGENTINA, Y LA SEGUNDA PARTE EN
                            PERÚ EN 1937. LA OBRA FUE
                            TRANSMITIDA POR RADIO NACIONAL EN
                            30 JORNADAS, PROTAGONIZADA POR LA
                            ACTRIZ MEXICANA COLUMBA QUINTANA,
                            Y DE ESTA MANERA SE INICIARON LAS
                            NOVELAS RADIOFÓNICAS EN EL PERÚ.
                            CON ESTE APORTE A LA INCIPIENTE
                            RADIO NACIONAL, ALVARADO BUSCA
                            REIVINDICAR A LA ACTRIZ MICAELA
                            VILLEGAS, EXPLORANDO SU PSICOLOGÍA
                            Y SU VIDA FAMILIAR MÁS ALLÁ DE SU
                            VÍNCULO AMOROSO CON EL VIRREY
                            MANUEL DE AMAT.
                        </p>
                    </div>
                    <div class="col-sm-6 c100">
                        <p class="fontMS500 font-24 mt-5 text-white">
                            MARÍA JESÚS ALVARADO ESCRIBIÓ LA
                            PRIMERA PARTE DE LA PERRICHOLI EN
                            1936, MIENTRAS ESTUVO EXILIADA EN
                            ARGENTINA, Y LA SEGUNDA PARTE EN
                            PERÚ EN 1937. LA OBRA FUE
                            TRANSMITIDA POR RADIO NACIONAL EN
                            30 JORNADAS, PROTAGONIZADA POR LA
                            ACTRIZ MEXICANA COLUMBA QUINTANA,
                            Y DE ESTA MANERA SE INICIARON LAS
                            NOVELAS RADIOFÓNICAS EN EL PERÚ.
                            CON ESTE APORTE A LA INCIPIENTE
                            RADIO NACIONAL, ALVARADO BUSCA
                            REIVINDICAR A LA ACTRIZ MICAELA
                            VILLEGAS, EXPLORANDO SU PSICOLOGÍA
                            Y SU VIDA FAMILIAR MÁS ALLÁ DE SU
                            VÍNCULO AMOROSO CON EL VIRREY
                            MANUEL DE AMAT.
                        </p>
                    </div>
                    <div class="col-sm-1"></div>
                </div>
                <div class="row mt-5">
                    <div class="col-sm-3"></div>
                    <div class="col-sm-3 libro mt-4">
                        <a href="http://hdl.handle.net/20.500.14428/79162" target="_blank" style="color: black;">
                            <img class="img-fluid" width="100%" 
                                src="/assets/images/micrositio/micrositio20/MUJER-031.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        María Jesús Alvarado. 
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        La Perricholi, primera parte. 
                                        <br>
                                    </span>
                                    Lima: [s.n.], 1946. 
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-3 libro mt-4">
                        <a href="http://hdl.handle.net/20.500.14428/79163" target="_blank" style="color: black;">
                            <img class="img-fluid" width="100%" 
                                src="/assets/images/micrositio/micrositio20/MUJER-032.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        María Jesús Alvarado. 
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        La Perricholi, segunda parte.   
                                        <br>
                                    </span>
                                    Lima: [s.n], 1946. 
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-3"></div>
                </div>

            </div>
        </div>
    </div>
</div>

<div class="fondoCeleste">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div style="margin-bottom: 5%;" class="row">
                    <div class="col-sm-4">
                        <p style="line-height: 130%;margin-bottom: 0%;" class="fontMS500 text-white font-70">
                            Espacio <br> de diálogo
                        </p>
                    </div>
                    <div class="col-sm-8">
                        <img id="img_dialogo"
                            src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_DIALOGO1.png">
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <p class="text-justify text-white font-28">
                            <br>
                            Estas activistas entendían que las diferencias de clase, raza y etnicidad afectan las experiencias
                            de las mujeres. Sus proyectos buscaban transformar la situación de la mujer, pero a la vez iban
                            más allá del género.
                            <br><br>
                        </p>
                    </div>
                    <div class="row mt-4">
                        <div class="col-sm-4">
                            <p class="fontMS500  text-white font-28">
                                Investiga más sobre una de
                                las activistas. ¿Qué reformas
                                promovieron? ¿Las reformas
                                han sido implementadas?
                                <br><br>
                                <img class="c100 mt-3" width="100%"
                                    src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_DIALOGO2.png">
                            </p>
                        </div>
                        <div class="col-sm-4">
                            <p class="fontMS500  text-white font-28">
                                Revisa los artículos y los
                                artículos y folletos
                                relacionados con la lucha por
                                el sufragio. ¿En qué consiste
                                el voto femenino calificado?
                                ¿A quiénes excluía? ¿Por qué?
                                <br><br>
                                <img class="c100 mt-3" width="100%"
                                    src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_DIALOGO2.png">
                            </p>
                        </div>
                        <div class="col-sm-4">
                            <p class="fontMS500  text-white font-28">
                                En los cuentos de Ángela
                                Ramos, Magda Portal y Rosa
                                Arciniega, ¿cómo es la mujer
                                moderna? ¿cómo se
                                diferencia de las mujeres de
                                otras generaciones?
                                <br><br>
                                <img class="c100 mt-3" width="100%"
                                    src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_DIALOGO2.png">
                            </p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-4">
                        <img class="bottom_cel" width="100%"
                                src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                    </div>
                    <div class="col-sm-4">
                        <img class="bottom_cel" width="100%"
                                src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                    </div>
                    <div class="col-sm-4">
                        <img class="bottom_cel" width="100%"
                                src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec bottom_cel" width="100%" style="margin-bottom:20%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada2.png">
                        <img class="LineSubsec c100" width="100%" style="margin-bottom:0%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada2.png">
                    </div>
                    <div class="col-sm-4 text-center">
                        <p style="line-height: 200%;margin-top: 10%;"
                            class="fontMS700 text-center font-40 colorPrincipal bottom_cel">
                            PARA SABER MÁS
                        </p>
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center font-40 colorPrincipal c100">
                            PARA SABER MÁS
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec bottom_cel" width="100%" style="margin-bottom:20%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada2.png">
                        <img class="LineSubsec c100" width="100%" style="margin-bottom:0%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada2.png">
                    </div>
                </div>
                <p class="fontMS100 font-24">
                    <br>
                    Recomendamos algunas de las fuentes consultadas durante la investigación.
                    <br>
                </p>
                <div class="row ">
                    <div class="col-sm-6">
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">
                                Miloslavich, D. (2015)
                            </span><br>
                            <span class="fontMS100 text-gris">
                                Feminismo y sufragio 1931-1955. En:
                                Elecciones (15): 109-143.<br></span>
                            <span class="text-gris">
                                https://dialnet.unirioja.es/servlet/articulo?codigo=6783427
                            </span><br>
                            <a href="https://dialnet.unirioja.es/servlet/articulo?codigo=6783427" target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">
                                Pachas Maceda, S. (2019)
                            </span><br>
                            <span class="fontMS100 text-gris">
                                Zoila Aurora Cáceres y la ciudadanía
                                femenina. Lima: JNE; UNMSM; CMP Flora
                                Tristán.<br></span>
                            <span class="text-gris">
                                http://info.bnp.gob.pe:80/cgi-bin/abnopac?TITN=581969
                            </span><br>
                            <a href="http://info.bnp.gob.pe:80/cgi-bin/abnopac?TITN=581969" target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">
                                Rojas Benavente,  L. (2007)
                            </span><br>
                            <span class="fontMS100 text-gris">
                                María Jesús Alvarado Rivera, primera feminista peruana. 
                                En: Revista Canadiense de Estudios Hispánicos 32(1): 149-163.  
                            </span>
                            <span class="text-gris">
                                https://www.jstor.org/stable/27764181 
                            </span><br>
                            <a href="https://www.jstor.org/stable/27764181 " target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">
                                Rojas Benavente, L. (2013)
                            </span><br>
                            <span class="fontMS100 text-gris">
                                Zarela, una historia feminista novela de
                                Leonor Espinoza de Menéndez: sin
                                educación la mujer no avanza. En:
                                Consensus 18(1), 99-113.
                            </span>
                            <span class="text-gris">
                                https://doi.org/10.33539/consensus.2014.v18n1.956
                            </span><br>
                            <a href="https://doi.org/10.33539/consensus.2014.v18n1.956" target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">
                                Zegarra, M. (2011)
                            </span><br>
                            <span class="fontMS100 text-gris">
                                María Jesús Alvarado: la construcción de una
                                intelectual feminista en Lima, 1878-1915.
                                Tesis de maestría, UNMSM.
                            </span>
                            <span class="text-gris">
                                https://cybertesis.unmsm.edu.pe/bitstream/h
                                andle/20.500.12672/1372/Zegarra_fm.pdf?se
                                quence=1
                            </span><br>
                            <a href="https://cybertesis.unmsm.edu.pe/bitstream/handle/20.500.12672/1372/Zegarra_fm.pdf?sequence=1" target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Footer -->
